<template>
    <div>
        <home></home>
        <div class="pagerc">
            <div class="headerimg">
                <img class="pcshow" src="../assets/images/lx.jpg" alt="">
                <img class="mshow" src="../assets/images/mlx.png" alt="">
                <div class="title">
                    <div class="titlep">
                        <h3>联系我们</h3>
                        <h4>CONTACT US</h4>
                    </div>
                </div>
            </div>
            <div class="inchild clear">
                <div class="wrapleft">
                    <h2>详情联系</h2>
                    <div class="contactbox">
                        <div class="cblx">
                            <div class="inlinecontact">
                                <h5>赞助联系人：</h5>
                                <ul>
                                    <li><i class="el-icon-coordinate"></i> Mag</li>
                                    <li><i class="el-icon-phone-outline"></i> 021-68405597</li>
                                    <li><i class="el-icon-message"></i> mag@hrflag.com</li>
                                </ul>
                                <ul class="contactus">
                                    <li><i class="el-icon-coordinate"></i> Dove</li>
                                    <li><i class="el-icon-phone-outline"></i> +86-010-80908448</li>
                                    <li><i class="el-icon-message"></i> dove@hrflag.com</li>
                                </ul>
                            </div>
                            <div class="inlinecontact">
                                <h5>报名联系人：</h5>
                                 <ul>
                                    <li><i class="el-icon-coordinate"></i> Luffy Liu</li>
                                    <li><i class="el-icon-phone-outline"></i> +86-021-6840-3875</li>
                                    <li><i class="el-icon-message"></i> luffy@hrflag.com</li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
                <wrapleft></wrapleft>
            </div>
        </div>
        <foots></foots>
    </div>
</template>

<script>
import home from '@/components/commn/home'
  import foots from '@/components/commn/foots'
  import wrapleft from '@/components/commn/wrapleft'
 export default {
      components:{
        home,
        foots,
        wrapleft
      },
        metaInfo: {
            title: '联系我们-第42届全球人才评鉴高峰会暨领导人才发展论坛',
            meta: [
            {
                name: 'keywords',
                content: '第42届全球人才评鉴高峰会，领导人才发展论坛'
            },
            {
                name: 'description',
                content: '有需要参展和赞助参展的朋友，请联系第42届全球人才评鉴高峰会暨领导人才发展论坛的主办方。'
            }
            ]
        },
}
</script>

<style>
    @import url('../assets/css/inpublic.css');
    
</style>



// WEBPACK FOOTER //
// src/components/contact.vue